export default __webpack_public_path__ + "static/stickerslike-1a59155a6b8a74028842ad5d0efcf101.png";